export default __webpack_public_path__ + "static/media/image-not-found1.9a5eb8c3.png";